import {Component, OnInit, inject} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {DataService} from "../../../services/data.service";
import {AccessService} from "../../../services/access.service";
import {ViewMode} from "../../interfaces";
import Swal from "sweetalert2";
import {FormService} from "../../../services/form.service";
import {NgIf} from '@angular/common';

@Component({
    selector: 'app-region-detail',
    templateUrl: './region-detail.component.html',
    styleUrl: './region-detail.component.scss',
    imports: [NgIf, FormsModule, ReactiveFormsModule]
})
export class RegionDetailComponent implements OnInit {

    accessService = inject(AccessService);
    formService = inject(FormService);
    private router = inject(Router);
    private fb = inject(UntypedFormBuilder);
    private dataService = inject(DataService);
    private route = inject(ActivatedRoute);

    readonly ViewMode = ViewMode;

    form!: UntypedFormGroup;
    id_region!: string;
    viewMode!: ViewMode;
    region: any;

    ngOnInit(): void {
        this.id_region = this.route.snapshot.paramMap.get('id');
        this.viewMode = this.id_region == '0' ? ViewMode.INSERT : ViewMode.VIEW;

        this.form = this.fb.group({
            id: [null],
            region: ['', Validators.required],
            countries: ['', Validators.required],
        });

        if (this.id_region !== '0') {
            this.getRegion();
        }
    }

    getRegion(): void {
        this.dataService.request('Region/get', {
            id_region: this.id_region
        }).subscribe(response => {
            this.region = response.region;

            this.patchForm();
        });
    }

    patchForm(): void {
        this.form.patchValue({
            id: this.region.id,
            region: this.region.region,
            countries: this.region.countries,
        });
    }

    save(): void {
        this.dataService.request('Region/save', {
            region: this.form.getRawValue(),
        }).subscribe(() => {
            this.router.navigate(['/region']);
        });
    }

    update(): void {
        this.dataService.request('Region/update', {
            region: this.form.getRawValue(),
        }).subscribe(() => {
            this.setMode(ViewMode.VIEW);
            this.getRegion();
        });
    }

    cancel(): void {
        this.router.navigate(['/region']);
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
    }

    delete(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Der Länderbereich wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('Region/delete', {
                    id_region: this.id_region
                }).subscribe(() => {
                    this.cancel();
                });
            }
        });
    }
}
